import { render, staticRenderFns } from "./JwJiaocaiKuncunList.vue?vue&type=template&id=614b6a67&scoped=true"
import script from "./JwJiaocaiKuncunList.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiKuncunList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614b6a67",
  null
  
)

export default component.exports